// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html, body, #root {\r\n  font-family: 'Nunito';\r\n  width: 100%;\r\n  height: 100%;\r\n  margin: 0;\r\n  background-color: #F5F6FA;;\r\n}\r\n\r\n.MuiTableCell-root{\r\n  padding:4px !important ;\r\n}", ""]);
// Exports
module.exports = exports;
